import { createSlice } from "@reduxjs/toolkit";
import {
  getFilteredDataRepo,
  getJobOpeningsRepo,
  postJobOpeningsRepo,
} from "../repositories/jobOpenings";

const jobOpeningsSlice = createSlice({
  name: "jobOpeningsReducer",
  initialState: {
    jobOpeningsLoading: false,
    jobOpeningsData: null,
    jobOpeningsError: null,

    postJobOpeningsLoading: false,
    postJobOpeningsData: null,
    postJobOpeningsError: null,

    companyFilterLoading: false,
    companyFilterData: null,
    companyFilterError: null,

    jobProfileFilterLoading: false,
    jobProfileFilterData: null,
    jobProfileFilterError: null,

    jobStatusFilterLoading: false,
    jobStatusFilterData: null,
    jobStatusFilterError: null,

    locationFilterLoading: false,
    locationFilterData: null,
    locationFilterError: null,

    designationFilterLoading: false,
    designationFilterData: null,
    designationFilterError: null,

    jobTypeFilterLoading: false,
    jobTypeFilterData: null,
    jobTypeFilterError: null,

    message: null,
  },
  reducers: {
    getJobOpeningsLoading(state, action) {
      return {
        ...state,
        jobOpeningsLoading: true,
      };
    },
    getJobOpeningsSuccess(state, action) {
      return {
        ...state,
        jobOpeningsLoading: false,
        jobOpeningsData: action.payload,
      };
    },
    getJobOpeningsFailure(state, action) {
      return {
        ...state,
        jobOpeningsLoading: false,
        jobOpeningsError: action.payload,
      };
    },

    postJobOpeningsLoading(state, action) {
      return {
        ...state,
        postJobOpeningsLoading: true,
      };
    },
    postJobOpeningsSuccess(state, action) {
      return {
        ...state,
        postJobOpeningsLoading: false,
        postJobOpeningsData: action.payload,
        message: "Job openings added Successfully",
      };
    },
    postJobOpeningsFailure(state, action) {
      return {
        ...state,
        postJobOpeningsLoading: false,
        postJobOpeningsError: action.payload,
        message: action.payload,
      };
    },

    getCompanyFilterLoading(state, action) {
      return {
        ...state,
        companyFilterLoading: true,
      };
    },
    getCompanyFilterSuccess(state, action) {
      return {
        ...state,
        companyFilterLoading: false,
        companyFilterData: action.payload,
      };
    },
    getCompanyFilterFailure(state, action) {
      return {
        ...state,
        companyFilterLoading: false,
        companyFilterError: action.payload,
      };
    },

    getJobProfileFilterLoading(state, action) {
      return {
        ...state,
        jobProfileFilterLoading: true,
      };
    },
    getJobProfileFilterSuccess(state, action) {
      return {
        ...state,
        jobProfileFilterLoading: false,
        jobProfileFilterData: action.payload,
      };
    },
    getJobProfileFilterFailure(state, action) {
      return {
        ...state,
        jobProfileFilterLoading: false,
        jobProfileFilterError: action.payload,
      };
    },

    //job status filter reducers

    getJobStatusFilterLoading(state, action) {
      return {
        ...state,
        jobStatusFilterLoading: true,
      };
    },
    getJobStatusFilterSuccess(state, action) {
      return {
        ...state,
        jobStatusFilterLoading: false,
        jobStatusFilterData: action.payload,
      };
    },
    getJobStatusFilterFailure(state, action) {
      return {
        ...state,
        jobStatusFilterLoading: false,
        jobStatusFilterError: action.payload,
      };
    },

    //location filter reducers

    getLocationFilterLoading(state, action) {
      return {
        ...state,
        locationFilterLoading: true,
      };
    },
    getLocationFilterSuccess(state, action) {
      return {
        ...state,
        locationFilterLoading: false,
        locationFilterData: action.payload,
      };
    },
    getLocationFilterFailure(state, action) {
      return {
        ...state,
        locationFilterLoading: false,
        locationFilterError: action.payload,
      };
    },

    //designation filter reducers
    getDesignationFilterLoading(state, action) {
      return {
        ...state,
        designationFilterLoading: true,
      };
    },
    getDesignationFilterSuccess(state, action) {
      return {
        ...state,
        designationFilterLoading: false,
        designationFilterData: action.payload,
      };
    },
    getDesignationFilterFailure(state, action) {
      return {
        ...state,
        locationFilterLoading: false,
        designationFilterError: action.payload,
      };
    },

    //job type filter reducers
    getJobTypeFilterLoading(state, action) {
      return {
        ...state,
        jobTypeFilterLoading: true,
      };
    },
    getJobTypeFilterSuccess(state, action) {
      return {
        ...state,
        jobTypeFilterLoading: false,
        jobTypeFilterData: action.payload,
      };
    },
    getJobTypeFilterFailure(state, action) {
      return {
        ...state,
        jobTypeFilterLoading: false,
        jobTypeFilterError: action.payload,
      };
    },

    clearMessage(state, action) {
      return {
        ...state,
        message: null,
        postJobOpeningsError: null,
      };
    },

    clearData(state, action) {
      return {
        ...state,
        message: null,
        postJobOpeningsData: null,
      };
    },
  },
});

export const {
  getJobOpeningsLoading,
  getJobOpeningsSuccess,
  getJobOpeningsFailure,

  postJobOpeningsLoading,
  postJobOpeningsSuccess,
  postJobOpeningsFailure,

  getCompanyFilterLoading,
  getCompanyFilterSuccess,
  getCompanyFilterFailure,

  getJobProfileFilterLoading,
  getJobProfileFilterSuccess,
  getJobProfileFilterFailure,

  getJobStatusFilterLoading,
  getJobStatusFilterSuccess,
  getJobStatusFilterFailure,

  getLocationFilterLoading,
  getLocationFilterSuccess,
  getLocationFilterFailure,

  getDesignationFilterLoading,
  getDesignationFilterSuccess,
  getDesignationFilterFailure,

  getJobTypeFilterLoading,
  getJobTypeFilterSuccess,
  getJobTypeFilterFailure,

  clearMessage,
  clearData,
} = jobOpeningsSlice.actions;

export const getJobOpenings = (params) => {
  return async (dispatch) => {
    dispatch(getJobOpeningsLoading());
    await getJobOpeningsRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getJobOpeningsSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getJobOpeningsFailure(error.message));
        }
      });
  };
};

export const postJobOpenings = (data) => {
  return async (dispatch) => {
    dispatch(postJobOpeningsLoading());
    await postJobOpeningsRepo(data)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(postJobOpeningsSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postJobOpeningsFailure(error.response?.data?.message));
        }
      });
  };
};

export const getCompanyFilter = (params) => {
  return async (dispatch) => {
    dispatch(getCompanyFilterLoading());
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getCompanyFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCompanyFilterFailure(error.message));
        }
      });
  };
};

export const getJobProfileFilter = (params) => {
  return async (dispatch) => {
    dispatch(getJobProfileFilterLoading());
    //same for all filtered data
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getJobProfileFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getJobProfileFilterFailure(error.message));
        }
      });
  };
};

export const getJobStatusFilter = (params) => {
  return async (dispatch) => {
    dispatch(getJobStatusFilterLoading());
    //same for all filtered data
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getJobStatusFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getJobStatusFilterFailure(error.message));
        }
      });
  };
};

export const getLocationFilter = (params) => {
  return async (dispatch) => {
    dispatch(getLocationFilterLoading());
    //same for all filtered data
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getLocationFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getLocationFilterFailure(error.message));
        }
      });
  };
};

export const getDesignationFilter = (params) => {
  return async (dispatch) => {
    dispatch(getDesignationFilterLoading());
    //same for all filtered data
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getDesignationFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDesignationFilterFailure(error.message));
        }
      });
  };
};

export const getJobTypeFilter = (params) => {
  return async (dispatch) => {
    dispatch(getJobTypeFilterLoading());
    //same for all filtered data
    await getFilteredDataRepo(params)
      .then((response) => {
        if (response?.status >= 200 || response?.status <= 300) {
          dispatch(getJobTypeFilterSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getJobTypeFilterFailure(error.message));
        }
      });
  };
};

// clear post
export const clearPostSuccessData = () => {
  return () => {
    dispatch(clearData);
  };
};
export const clearPostErrorData = () => {
  return () => {
    dispatch(clearMessage);
  };
};

export default jobOpeningsSlice.reducer;
